import { BreadcrumContext } from "@shared/components";
import { gql, useQuery } from "@shared/utils";
import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";
import { useProductConfigurationVariables } from "../providers/ProductConfigurationVariables";
export const BreadcrumProvider = ({ children }: PropsWithChildren<any>) => {
  const nav = useNavigate();
  const { productConfiguration, setProductConfiguration } =
    useProductConfigurationVariables();
  const items = [
    {
      title: "Product Configurations",
      onClick: () => {
        nav("/");
      },
    },
  ];
  const productConfigurationInfo = useQuery<{
    productConfiguration?: { name: string; _id: string };
  }>(
    gql`
      query ProductConfiguration($productConfiguration: ID!) {
        productConfiguration(id: $productConfiguration) {
          _id
          name
        }
      }
    `,
    { variables: { productConfiguration } }
  );
  if (productConfigurationInfo?.data?.productConfiguration) {
    items.push({
      title: productConfigurationInfo?.data?.productConfiguration?.name,
      onClick: () => {
        setProductConfiguration(
          productConfigurationInfo?.data?.productConfiguration?._id
        );
      },
    });
  }
  return (
    <BreadcrumContext.Provider value={{ items }}>
      {children}
    </BreadcrumContext.Provider>
  );
};
